import { Component, EventEmitter, Input, Output } from '@angular/core';

export interface PasswordFormValue {
  currentPassword?: string;
  newPassword: string;
}

@Component({
  selector: 'app-password-form',
  templateUrl: './password-form.component.html',
  styleUrls: ['./password-form.component.scss'],
  standalone: false,
})
export class PasswordFormComponent {
  @Input() showCurrentPassword = true;
  @Input() loading = false;
  @Input() error = '';
  @Input() success = '';
  @Input() submitLabel = 'Save password';
  @Input() loadingLabel = 'Saving...';
  @Input() cancelLabel = 'Cancel';

  @Output() passwordSubmit = new EventEmitter<PasswordFormValue>();
  @Output() canceled = new EventEmitter<void>();

  submitted = false;

  form = {
    currentPassword: '',
    newPassword: '',
    confirmNewPassword: '',
  };

  get currentPasswordTooShort(): boolean {
    return (
      this.showCurrentPassword &&
      this.form.currentPassword.length > 0 &&
      this.form.currentPassword.length < 8
    );
  }

  get newPasswordTooShort(): boolean {
    return this.form.newPassword.length > 0 && this.form.newPassword.length < 8;
  }

  get newPasswordsDoNotMatch(): boolean {
    return (
      this.form.confirmNewPassword.length > 0 &&
      this.form.newPassword !== this.form.confirmNewPassword
    );
  }

  get formInvalid(): boolean {
    return (
      (this.showCurrentPassword &&
        (!this.form.currentPassword || this.form.currentPassword.length < 8)) ||
      !this.form.newPassword ||
      !this.form.confirmNewPassword ||
      this.form.newPassword.length < 8 ||
      this.form.newPassword !== this.form.confirmNewPassword
    );
  }

  submit(): void {
    this.submitted = true;

    if (this.formInvalid) {
      return;
    }

    this.passwordSubmit.emit({
      currentPassword: this.showCurrentPassword ? this.form.currentPassword : undefined,
      newPassword: this.form.newPassword,
    });
  }

  cancel(): void {
    this.canceled.emit();
  }
}
